import styled from 'styled-components';

type SurveyProps = {
  branding: {
    brand_color?: string | null;
    body_background_color?: string | null;
    question_text_color?: string | null;
    question_background_color?: string | null;
  };
};

export const StyledSurveyBuilder = styled.div<SurveyProps>`
  overflow: auto;
  width: 100%;
  height: 100%;
  .secondary-header {
    padding: 0 15px;
    border-bottom: 1px solid #cfd7df;
    position: sticky;
    z-index: 7;
    top: 0;
    background-color: #ffffff;
    box-shadow: 0 2px 4px 0 rgb(24 50 71 / 8%);

    .step {
      opacity: 0.5;
      display: flex;
      align-items: center;
    }

    .title {
      padding: 20px 0 10px 0;
      display: inline-block;

      input,
      .editable-text {
        font-size: 20px;
        font-weight: 600;
      }
      input {
        transition: all linear 0.25s;
        // margin-left: -5px;
      }
    }
  }

  .questions-builder {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: ${({ branding }) =>
      branding?.body_background_color
        ? branding.body_background_color
        : '#ebeff3'};
    padding-top: 20px;
    --brand-color: ${({ branding }) => {
      return branding?.brand_color || '#264966';
    }};

    --question-text-color: ${({ branding }) =>
      branding?.question_text_color
        ? branding.question_text_color
        : 'var(--color-elephant-900)'};
    --question-background: ${({ branding }) =>
      branding?.question_background_color
        ? branding.question_background_color
        : '#fff'};

    .status-banner {
      background: ${({ branding }) =>
        branding?.body_background_color
          ? branding.body_background_color
          : '#ebeff3'};
    }

    .text-lg {
      color: var(--question-text-color);
      font-size: 16px;
      font-weight: 600;
    }

    p {
      margin: 10px 0;
      color: var(--color-smoke-800);
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;
    }
    .field {
      display: flex;
      align-items: flex-start;
      padding: 20px 20px 0;
      width: 700px;
    }
    .add-step {
      user-select: none;
      background: #ffffff;
      box-shadow: 0px 2px 5px rgba(18, 52, 77, 0.1);
      border-radius: 50%;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      max-width: 52px;
      height: 52px;
      width: 100%;
      font-weight: 600;

      &.disabled {
        background: var(--color-smoke-25);
        cursor: not-allowed;
      }
      span {
        font-size: 24px;
        margin-top: -5px;
      }
      .btn-label {
        max-width: 0;
        opacity: 0;
        position: relative;
        left: 15px;
        transition: 20ms opacity linear, 300ms max-width linear;
        white-space: nowrap;
      }
    }

    .add-step.open,
    .add-step:hover {
      border-radius: 40px;
      max-width: max-content;
      padding: 18px;
      .btn-label {
        margin-right: 15px;
        max-width: max-content;
        opacity: 1;
      }
    }

    .builder-header {
      margin: 11px 0 10px;
      .editable-text {
        line-height: 1.8;
        white-space: nowrap;
      }
      textarea {
        min-width: 480px;
        min-height: 100px;
      }
    }

    .nps-title {
      font-size: 16px;
      font-weight: 600;
      margin-left: 30px;
      margin-top: 20px;
      padding-bottom: 20px;
    }

    .open .nps-title {
      margin-top: 40px;
      padding-bottom: 0;
    }

    .section-configuration {
      display: flex;
      justify-content: space-between;
      margin: 25px 35px 0;
      .form-field {
        width: calc(50% - 10px);

        label {
          display: block;
          font-size: var(--font-size-12);
          color: var(--color-smoke-700);
          font-weight: 500;
        }
        .option {
          margin-top: 5px;

          .dropdown-button {
            min-height: 35px;
          }
        }
      }
    }

    .section {
      background: var(--question-background);
      border-radius: 4px;
      width: 700px;
      margin: 20px 0;
      box-shadow: var(--shadow-md);
      transform: scale(1);
      transition: transform 400ms ease 0ms, visibility 200ms ease 0ms,
        opacity 200ms ease 0ms, border-width 200ms ease-out,
        box-shadow 200ms ease-out;
      border: 1px solid #92a2b1;
      border-width: 0;

      &.has-error {
        border: 2px solid var(--text-danger);
      }

      &.open {
        box-shadow: 0px 2px 16px rgba(18, 52, 77, 0.1);

        .section-title {
          opacity: 1;
        }
      }

      &.highlighted {
        box-shadow: 0px 0px 1px 2px rgba(9, 12, 43, 0.2);
      }

      .section-description.required::after {
        content: '*';
        position: relative;
        top: -2px;
        font-size: 14px;
        color: var(--text-danger);
        padding-left: 3px;
        font-weight: 700;
      }

      .section-title {
        display: flex;
        align-items: center;
        font-weight: 600;
        font-size: 14px;
        color: var(--color-elephant-850);
        opacity: 0.45;
        .question-identifier-section {
          max-width: 200px;
        }
        .icon {
          margin-right: 5px;
        }

        .section-type {
          margin-right: 10px;
          padding-right: 10px;
          border-right: 1px solid var(--color-smoke-100);
          white-space: nowrap;
        }
      }

      .section-type {
        display: flex;
        align-items: center;
      }

      .section-required {
        position: relative;
        margin-left: 10px;
        display: flex;
        align-items: center;
        padding: 5px 10px;
        background: #ebeff3;
        border-radius: 4px;
        &.report {
          padding: 5px;
        }
        .icon {
          margin: 0;
        }
      }

      .section-question {
        margin: 10px 25px 0;
        padding: 10px 0 0 0;
      }
      .section-description {
        font-weight: 600;
        font-size: 16px;
        margin: 0;
      }
      .section-content {
        padding: 10px;
      }
      .section-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #ffffff;
        border-radius: 6px 6px 0 0;
        padding: 15px 5px 7px 25px;
        min-height: 40px;
        border-bottom: 1px solid #ebeff3;
        background: #fff;
        padding: 5px 5px 5px 15px;
        button {
          background: var(--color-smoke-25);
          border-color: var(--color-smoke-50);
        }
        button:hover {
          background: var(--color-smoke-50);
          border-color: var(--color-smoke-100);
        }
      }
    }
  }
  .nav {
    height: 56px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #ffffff;

    .tab-container {
      padding: 10px 16px 0 16px;
      background: #ffffff;
      //box-shadow: 0px 2px 4px rgba(207, 215, 223, 0.3);
      //border-radius: 4px;
      div[role='tab'] {
        margin-right: 24px;
      }

      span.label {
        padding: 8px 12px 13px;
      }
    }
  }

  .brand-logo {
    img {
      width: 180px;
    }
    h3 {
      text-align: center;
      margin: 0;
      font-weight: 600;
      font-size: 24px;
      line-height: 29px;
      color: var(--color-elephant-900);
    }
  }

  .nav-actions button {
    margin-left: 10px;
  }
  .nav-actions {
    height: 31px;
  }

  .nav-steps ul li span {
    color: var(--color-elephant-900);
  }

  .nav-steps ul li label {
    padding: 0 5px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    margin-right: 5px;
    background: transparent;
    border: 1px solid var(--color-smoke-300);
  }
  .nav-steps ul li.active label {
    color: white;
    background: var(--color-elephant-900);
    border: 1px solid var(--color-elephant-900);
  }

  .nav-steps ul li.active {
    color: var(--color-elephant-900);
    font-weight: 600;
  }
  .nav-steps ul li.completed label {
    color: white;
    background: var(--color-jungle-800);
    border: 1px solid var(--color-jungle-800);
  }

  .nav-steps ul li.completed {
    color: var(--color-jungle-800);
    font-weight: 600;
  }
  .nav-steps ul li.error {
    color: var(--color-persimmon-800);
    font-weight: normal;
  }
  .nav-steps ul li.error label {
    color: white;
    background: var(--color-persimmon-800);
    border: 1px solid var(--color-persimmon-800);
  }
  .nav-steps ul li {
    margin-right: 10px;
    list-style: none;
    display: flex;
    cursor: pointer;
    align-items: center;
    color: var(--color-smoke-300);
    font-weight: 500;
  }
  .nav-steps ul .step {
    margin-right: 10px;
  }
  .nav-steps ul {
    display: flex;
  }

  .nav-actions {
    display: flex;
  }

  .question-container {
    padding: 10px 15px 10px 25px;
    &.open {
      padding: 20px 35px 20px 35px;
    }
    > div {
      width: 100%;
    }
  }
  .rating-tabs {
    border-bottom: 1px solid #d3d3d3;
    .label {
      padding: 14px;
    }
  }
`;
